import Cookies from 'js-cookie';

const TokenKey = "ELD-Sales-Token";

export function getELDToken() {
  return Cookies.get(TokenKey, { domain: 'truckerpath.com' });
}

export function removeELDToken() {
  return Cookies.remove(TokenKey, { domain: 'truckerpath.com' });
}


// WEBPACK FOOTER //
// ./src/components/pages/CreateAccount/cookie.js